// 회사소개
export default {
  path: '/:locale([en]*)?/question',
  name: 'Question',
  component: () => import('@/views/question/Index'),
  children: [
    {
      path: 'partnership',
      name: 'questionPartnership',
      component: () => import('@/views/question/Partnership'),
      meta: {
        language: false,
        parent: 'Question'
      }
    },
    {
      path: 'press',
      name: 'questionPress',
      component: () => import('@/views/question/Press'),
      meta: {
        language: false,
        parent: 'Question'
      }
    },
    {
      path: 'other',
      name: 'questionOther',
      component: () => import('@/views/question/Other'),
      meta: {
        language: false,
        parent: 'Question'
      }
    },
  ],
}
